import Vue from 'vue';
import VueRouter from 'vue-router';

import RegerativeWheel from '@/views/RegenerativeWheel.vue';


Vue.use(VueRouter);

const routes = [{ path: '*', component: RegerativeWheel }];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;